module.exports = __webpack_public_path__ + "img/ic_product_introduce.5a7911cf.png";